(function () {
  var drawer = document.getElementById('newsletter-drawer');
  if (!drawer) return;

  function open() {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('newsletter-drawer-open');
    var input = drawer.querySelector('input[type="email"]');
    if (input) setTimeout(function () { input.focus(); }, 280);
  }

  function close() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('newsletter-drawer-open');
  }

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-newsletter-drawer-toggle]');
    if (toggle) {
      e.preventDefault();
      open();
    }
  });

  drawer.querySelectorAll('[data-newsletter-drawer-close]').forEach(function (el) {
    el.addEventListener('click', close);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
  });

  if (window.location.hash === '#newsletter-subscribed') {
    open();
  }

  window.NewsletterDrawer = { open: open, close: close };
})();
